"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var DF = __importStar(require("date-fns"));
var react_1 = __importDefault(require("react"));
var versionManifest_1 = require("./versionManifest");
function useReleaseCabinet(onDisplay) {
    var manifest = react_1.default.useMemo(versionManifest_1.getVersionManifest, []);
    var renderManifest = react_1.default.useCallback(function () {
        var version = manifest.sha1.substring(0, 6);
        var created = DF.formatRelative(DF.parseISO(manifest.date), new Date());
        return "release: " + version + " (" + created + ")";
    }, [manifest]);
    react_1.default.useEffect(function () {
        console.info('%c' + renderManifest(), 'color: red; font-size: 18px');
    }, [renderManifest]);
    var displayNow = react_1.default.useCallback(function () {
        onDisplay(renderManifest());
    }, [onDisplay, renderManifest]);
    react_1.default.useEffect(function () {
        var handle = function (ev) {
            if (ev.altKey && ev.shiftKey && (ev.key === 'R' || ev.key === 'V')) {
                displayNow();
            }
        };
        document.addEventListener('keyup', handle);
        return function () {
            document.removeEventListener('keyup', handle);
        };
    }, [manifest, displayNow]);
    return displayNow;
}
exports.useReleaseCabinet = useReleaseCabinet;
//# sourceMappingURL=useReleaseCabinet.js.map